import { applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';

import { user } from './user';

export default composeWithDevTools(applyMiddleware(reduxThunk, user));
